// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3Ot6r","title":"BackImages_title__3XMzN","images":"BackImages_images__2VJk1"};